export function ErrorNote(props: { error: JSX.Element | string }) {
	return (
		<div>
			<p className="error-note">{props.error}</p>
		</div>
	);
}
